import { InjectionToken } from '@angular/core';

import { DictionaryItem } from '@hglobal/common';
import { Observable } from 'rxjs';

import { Country, Currencies, Skin, WalletsSkinCollection } from '@pp/core/entities';

export interface DictionariesApi {
  getRoles(): Observable<DictionaryItem<string>[]>;
  getCurrencies(): Observable<Currencies>;
  getCardsSkins(): Observable<Skin[]>;
  getWalletSkins(): Observable<WalletsSkinCollection>;
  getCountries(): Observable<Country[]>;
}

export const DICTIONARIES_API = new InjectionToken<DictionariesApi>('DICTIONARIES_API');
